import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignProductUidReducer = (state: DesignState, action: PayloadAction<string|undefined>) => {
  state.productUid = action.payload;
};

export default setDesignProductUidReducer;
